// extracted by mini-css-extract-plugin
export default {"menuMark":"Logout_menuMark__6RCxQ"};